import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonateNowComponent } from './components/donate-now/donate-now.component';
import { PaymentModule } from '../payment/payment.module';
import { TncComponent } from './components/tnc/tnc.component';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    PaymentModule,
    ModuleLoaderModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule
  ],
  declarations: [DonateNowComponent, TncComponent],
  exports: [DonateNowComponent]
})
export class DonateNowModule { }
